import {
  customTrayItemSchema,
  getBaseProductSchema,
  ItemTypeEnum,
  ProductTypeEnum,
  type CustomTrayProduct,
} from "@jasper/client-models";
import z from "zod";
import {
  TeethSelectionEnum,
  type ProductWorkflowConfiguration,
} from "./ProductWorkflowConfiguration";
import { StepKeysEnum } from "../../steps/types";
import { ArchStep } from "./constants";

export type CustomTrayStepKey = typeof StepKeysEnum.arch;

const customTrayArchesSchema = z.object({
  items: z.array(customTrayItemSchema).min(1),
});

export const CustomTrayWorkflowConfiguration: ProductWorkflowConfiguration<
  CustomTrayProduct,
  CustomTrayStepKey
> = {
  productType: ProductTypeEnum.customTray,
  itemType: ItemTypeEnum.customTray,
  steps: [new ArchStep()],
  teethSelection: TeethSelectionEnum.ARCH,
  isBulkSupported: true,

  isValidProduct(product) {
    return getBaseProductSchema({ itemSchema: customTrayItemSchema }).safeParse(
      product
    ).success;
  },

  getCompletedSteps(product) {
    return customTrayArchesSchema.safeParse(product).success
      ? [StepKeysEnum.arch]
      : [];
  },
};
